import axios from '@/plugins/axios';

export async function errors(params = {}){
    return await axios.get(`admin/errors/organization-import-debt-responses`, {params});
}